// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/style.scss
// module id = 1072
// module chunks = 65